import { GetterTree } from 'vuex'
import { WorkOvertimeApplication, WorkOvertimeApplicationsState } from '@/store/applications/workOvertime/types'
import { RootState } from '@/store/types'

const getters : GetterTree<WorkOvertimeApplicationsState, RootState> = {
  /**
   * 申請IDを元に時間外休日勤務申請情報を取得
   * @param {string} applicationId 申請ID
   * @return {WorkOvertimeApplication|null} 申請情報
   */
  findWorkOvertimeApplicationById:
    (state) => (applicationId: string): WorkOvertimeApplication|null => {
      return state.applications.find(
        (app: WorkOvertimeApplication) => app.id === applicationId,
      ) || null
    },
}

export default getters
